/**
 * Copyright 2018-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import axios from 'axios';
import ConfigUtils from '../utils/ConfigUtils';
import CoordinatesUtils from '../utils/CoordinatesUtils';
import LocaleUtils from '../utils/LocaleUtils';
import MapUtils from '../utils/MapUtils';
import CopyButton from '../components/widgets/CopyButton';
import Icon from '../components/Icon';
import displayCrsSelector from '../selectors/displaycrs';
import './style/MapInfoTooltip.css';

class XMsiges extends React.Component {
    static propTypes = {
        displaycrs: PropTypes.string,
        elevationPrecision: PropTypes.number,
        //enabled: PropTypes.bool,
	currentTask: PropTypes.string,//Ajout XM
        includeWGS84: PropTypes.bool,
        map: PropTypes.object
    }
    static defaultProps = {
        elevationPrecision: 0,
        includeWGS84: true
    }
    state = {
        coordinate: null, elevation: null, extraInfo: null
    }
    componentDidUpdate(prevProps, prevState) {
        //if (!this.props.enabled && this.state.coordinate) {
	if (this.props.currentTask !== prevProps.currentTask && prevProps.currentTask === "XMsiges") {//Ajout XM issu de Identify.jsx
            this.clear();
            return;
        }
        const newPoint = this.props.map.click;
        //if (!newPoint || newPoint.button !== 2) {
	if (!newPoint) {
            if (this.state.coordinate) {
                this.clear();
            }
        } else {
            const oldPoint = prevProps.map.click;
            if (!oldPoint || oldPoint.pixel[0] !== newPoint.pixel[0] || oldPoint.pixel[1] !== newPoint.pixel[1]) {
                this.setState({coordinate: newPoint.coordinate, elevation: null});
                const serviceParams = {pos: newPoint.coordinate.join(","), crs: this.props.map.projection};
		/*
		  AJOUTS XM POUR OBTENIR UN LIEN SIGES
		*/
		const coordonneesL93 = serviceParams.pos.split(",");
		const crsL93 = serviceParams.crs;
		//if (!this.props.enabled) {
		if (this.props.currentTask === "XMsiges") {
		    window.open('https://sigescen.brgm.fr/?page=logRegionalLISA&SRS=' + crsL93 + '&X=' + coordonneesL93[0] + '&Y=' + coordonneesL93[1]);
		    //window.alert('Cette tache se nomme '+ this.props.currentTask)
		 }
		/*
		  FIN DES AJOUTS XM
		*/
            }
        }
    }
    clear = () => {
        this.setState({coordinate: null, height: null, extraInfo: null});
    }
    render() {
        return null;
    }
    
}

const selector = createSelector([state => state, displayCrsSelector], (state, displaycrs) => ({
    //enabled: state.identify.tool !== null,
    currentTask: state.task.id,//Ajout XM issu de Identify.jsx
    map: state.map,
    displaycrs: displaycrs
}));

export default connect(selector, {})(XMsiges);
